import { useSearchParams } from 'react-router-dom';

export type PageVersion = 'original' | 'audited' | 'awesome';

/**
 * Hook do wyboru wersji strony na podstawie query param
 *
 * Użycie:
 * - /?version=audited -> wersja z poprawkami UX
 * - /?version=awesome -> nowy design Teachable
 * - / (domyślnie) -> oryginalna strona
 */
export function useVersionSelector(): PageVersion {
  const [searchParams] = useSearchParams();
  const version = searchParams.get('version');

  if (version === 'audited') return 'audited';
  if (version === 'awesome') return 'awesome';
  return 'original';
}
